import React from 'react';
import RadioFieldGroup from 'components/shared/RadioFieldGroup';
import RadioField from 'components/shared/RadioFieldGroup/RadioField';

const CanBeInstructorNote = ({ primary }) => (
  <div className="EditRole-secondaryOptions">
    <ul className="EditRole-secondaryOptions--disabled">
      <li>
        {primary
          ? t(
              'settings.tab.roles.edit.event_management_labels.can_manage_as_instructor',
            )
          : t(
              'settings.tab.roles.edit.event_management_labels.can_be_made_instructor',
            )}
      </li>
    </ul>
  </div>
);

const EventManagement = ({ disabled, selectedValue, onChange }) => (
  <div className="EditRole-section">
    <h3>{t('settings.tab.roles.edit.event_management.title')}</h3>
    <div className="EditRole-sectionDescription">
      {t('settings.tab.roles.edit.event_management.desc')}
    </div>
    <RadioFieldGroup
      name="eventManagement"
      disabled={disabled}
      selectedValue={selectedValue}
      onChange={e => {
        onChange(e);
      }}
    >
      <RadioField value="no_access">
        {t('settings.tab.roles.edit.event_management_labels.no_access')}
      </RadioField>
      <RadioField value="instruct_events">
        {t('settings.tab.roles.edit.event_management_labels.instruct_events')}
      </RadioField>
      <CanBeInstructorNote primary />
      <RadioField value="create_events">
        {t('settings.tab.roles.edit.event_management_labels.create_events')}
      </RadioField>
      <CanBeInstructorNote />
      <RadioField value="edit_all_events">
        {t('settings.tab.roles.edit.event_management_labels.edit_all_events')}
      </RadioField>
      <CanBeInstructorNote />
    </RadioFieldGroup>
  </div>
);

export default EventManagement;
